import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { countries } from 'src/@order/commonData/commonUiData';

@Component({
  selector: 'app-select-country-dialog',
  templateUrl: './select-country-dialog.component.html',
  styleUrls: ['./select-country-dialog.component.scss']
})
export class SelectCountryDialogComponent implements OnInit {
  countries = countries;
  heading;
  selectedCountry;
  listData: [] = [];
  selectedItem;
  btn: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<SelectCountryDialogComponent>,
  ) {
    this.heading = this._data?.heading;
    this.btn = this._data?.btn;
    console.log("this.selectedCountry", this._data?.selected);
    if (this._data?.selected) {
      this.onSelect(this._data?.selected);
    }
  }

  ngOnInit(): void {
    // console.log("_data -----> ", this._data);
    if (!this._data.isForCountries) {
      this.listData = JSON.parse(JSON.stringify((this.addNewKey(this._data.selectedCountryData))));

      if (this._data.selected) {
        this.listData.map((item: any) => {
          if (item.id == this._data.selected.id) {
            // console.log("item", item)
            item.isSelected = 1
          } else {

          }
        });
      }

    }

  }

  public onSelect(country) {
    this.countries.map(item => item.code == country.code ? item.selected = 1 : item.selected = 0)
    this.selectedCountry = country;
  }

  onSelectItem(item) {
    this.listData.map((ele: any) => ele.id == item.id ? ele.isSelected = 1 : ele.isSelected = 0)
    this.selectedItem = item;
  }

  public isCountrySelected() {
    if (this._data.isForCountries) {
      return !(this.countries.some(item => item.selected))
    } else {
      return !(this.listData.some((item: any) => item.isSelected))
    }
  }

  private addNewKey(array) {
    array.forEach((obj) => {
      obj['isSelected'] = 0;
    });
    return array;
  }

}
